module.exports = __webpack_public_path__ + "img/icon_vote_add.427eb6ab.png";